import { legacyHypernovaGetConfigForFetchUserEnvironment } from '#/config/legacyHypernovaConfigUtils';
import type { AppConfig } from '#/config/types/AppConfig';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiUserEnvironment } from './types/ApiUserEnvironment';

type ApiResponse = ApiUserEnvironment & {
  config: AppConfig;
};

function mapResponse(response: ApiResponse) {
  return {
    user: response.user,
    environment: response.environment,
    appConfig: HORIZON_ENABLED
      ? response.config
      : legacyHypernovaGetConfigForFetchUserEnvironment(),
  };
}

const endpoint = new FetchEndpoint({
  urlFactory: () => '/data/environment',
  mapResponse,
});

// Exports

export const apiFetchUserEnvironment = endpoint.createClientFetchFn();

export const apiIsomorphicFetchUserEnvironment =
  endpoint.createIsomorphicFetchFn();
